import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Users from "../views/Users.vue";
import Profile from "../views/Profile.vue";
import Calendar from "../views/Calendar.vue";
import NewUser from "../views/NewUser.vue";
import Posts from "../views/Posts.vue";
import Details from "../views/Details.vue";
import NewPost from "../views/NewPost.vue";
import library from "../views/Library.vue";
import NewPostMarketing from "../views/NewPostMarketing.vue";
import EditUser from "../views/EditUser.vue";
import DetailsAgendada from "../views/DetailsAgendada.vue";
import Stores from "../views/Lojas.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      header: 1,
    },
  },
  {
    path: "/Login",
    name: "Login",
    component: Login,
    meta: {
      header: 1,
    },
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/ForgotPassword",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      header: 1,
    },
  },
  {
    path: "/ResetPassword",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      header: 1,
    },
  },
  {
    path: "/Profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/Users",
    name: "Users",
    component: Users,
  },
  {
    path: "/Calendar",
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/NewUser",
    name: "NewUser",
    component: NewUser,
  },
  {
    path: "/Posts",
    name: "Posts",
    component: Posts,
  },
  {
    path: "/Details/:id",
    name: "Details",
    component: Details,
  },
  {
    path: "/DetailsAgendada/:id",
    name: "DetailsAgendada",
    component: DetailsAgendada,
  },
  {
    path: "/EditUser/:email",
    name: "EditUser",
    component: EditUser,
  },
  {
    path: "/NewPost",
    name: "NewPost",
    component: NewPost,
  },
  {
    path: "/library",
    name: "library",
    component: library,
  },
  {
    path: "/NewPostMarketing",
    name: "NewPostMarketing",
    component: NewPostMarketing,
  },
  {
    path: "/Stores",
    name: "Stores",
    component: Stores,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
